export default __webpack_public_path__ + "static/media/gradient.7e8f6069.png";